import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(1);
  const [transitionEnabled, setTransitionEnabled] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const sliderRef = useRef();

  const items = [
    {
      title: "Tamilpreneur Grand Sangamam 2025",
      description:
        "Last weekend at Tamilpreneur Grand Sangamam 2025, I expected just another networking event—but walked away with unexpected clarity. Amidst conversations and quiet keynotes, I realized: everyone’s building something, but few are building direction. We talk about scaling, yet without clarity, scale becomes chaos. From chatting with founders like Nivedha Shankar and creators like Epaphra T to witnessing agencies rethink stagnant offers, it hit me—sometimes, the right room asks better questions than any algorithm can. This event didn’t give me contacts; it gave me perspective. If you're building anything—business, brand, or content—go for the clarity you didn’t know you needed.",
      image: "LatestBuzz/3.jpg",
    },
    {
      title: "10 student internship",
      description:
        "From May 28 to June 17, Hanatoria became a vibrant space of growth as students—some seasoned, others just starting—joined our internship with curiosity and passion. Over three weeks, they explored design tools, creative thinking, and real-world problem-solving through hands-on tasks, feedback sessions, and team challenges. The experience wasn’t just about learning techniques—it was about building confidence, collaboration, and a deeper understanding of the design journey. Certificates were awarded on June 21, not just as proof of completion, but as a celebration of transformation. At Hanatoria, we don’t just offer exposure—we spark growth. To our interns: we’re proud of your journey, and to future learners—stay curious, your time is coming.",
      image: "LatestBuzz/1.jpg",
    },
    {
      title: "Aalamaram Demo Day",
      description:
        "Aalamaram Demo Day in Coimbatore wasn’t just an event—it felt like home. Surrounded by passionate founders and real stories, it reminded me why I started. Sridhar Vembu sir’s words—“Stop complaining about Tier‑2 talent. Create it. Nurture it. Believe in it”—deeply shifted my mindset. Ambi Moorthy, driving Aalamaram and GoZen, showed how grit and purpose can spark change: 23+ rural startups, 100+ jobs. What stayed with me was the people—their honesty and fire. Founders like Charanya, Vijay, Deepana, Karthik, and others. Startups like Backspace Tech, AtumX, and Brhat. This wasn’t just about ideas—it was about impact. Greatness grows from roots, not reach.",
      image: "LatestBuzz/2.jpg",
    },
    {
      title: "Nandri Viswasam: The Power of Gratitude and Trust for Growth",
      description:
        "In both life and work, two powerful values guide meaningful growth: Nandri (gratitude) and Viswasam (trust). These aren’t just ideals—they’re the fuel behind lasting relationships, collaboration, and success. Gratitude teaches us to value the people and moments that shape our journey, while trust forms the bedrock of every strong connection—whether with clients, teams, or communities. For anyone building something—an idea, a career, or a company—Nandri Viswasam becomes the foundation. When we honor the support we receive and nurture trust through our actions, we unlock deeper growth and impact. Let’s not just talk about values—let’s live them. Because gratitude and trust aren’t just good to have—they’re what take us forward.",
      image: "LatestBuzz/4.jpg",
    },
    {
      title: "Grateful to Be Part of Aalamaram’s Diwali Dinner Night ",
      description:
        "The Diwali Dinner Night hosted by Aalamaram was more than a celebration—it was inspiring.Founders from all walks came together, sharing ideas and stories that reignited our purpose.One highlight was the deep discussions on AI and its role in shaping industries.It wasn’t just tech talk—it was about real challenges and future possibilities.Each table sparked fresh ideas, honest insights, and meaningful connections.Huge thanks to Ambi Moorthy Sir and the Aalamaram team for curating this powerful space.Here’s to more such moments where community and clarity come together.",
      image: "LatestBuzz/5.jpg",
    },
    {
      title: "Exploring the Future at SaaS Connect 2025!",
      description:
        "SaaS Connect 2025 was a powerful gathering of minds shaping the future of SaaS and AI.Industry leaders, builders, and entrepreneurs explored where innovation is heading.Key themes included software-first models, AI-driven growth, and scalable systems.Discussions on autonomous agents and product-market fit were especially insightful.It wasn’t just about talks—it was real conversations and lasting connections.We left with fresh ideas, renewed purpose, and drive to build what’s next.The journey continues—and the best is still ahead.",
      image: "LatestBuzz/8.jpg",
    },
    {
      title: "Hanatoria 2nd year anniversary",
      description:
        "Celebrating 2 years of Hanatoria ❤️ — what began with one client and a clear vision has grown into 300+ clients served through impactful strategy, design, and digital marketing. This journey has been about more than numbers; it’s built on trust, consistency, and a passionate team driven by purpose. With our CEO’s vision and the support of Aalamaram Startup Incubator, Hanatoria has become a powerful force in the digital space. To our clients, team, and partners — this milestone is yours. Here's to more growth, more impact, and new stories ahead.",
      image: "LatestBuzz/10.jpg",
    },
    {
      title: " From Ideas to Impact: Hanatoria at the AWS Event",
      description:
        "Two years ago, Hanatoria began as a small team with a bold vision: to make quality design accessible to startups and growing businesses. The journey was filled with late nights, challenges, and learning—but our belief and our clients’ trust kept us going. Today, we’ve served 500+ clients, shaped 200+ brand identities, and empowered 300+ startups with creative solutions. Being part of the AWS Event Conference this week was a proud milestone. Huge thanks to Aalamaram Startup Incubator for their support. At Hanatoria, we’re not just designing—we’re building something that lasts.",
      image: "LatestBuzz/6.jpg",
    },
    {
      title: "Designing Futures at Rathinam College – A Day to Remember",
      description:
        "On January 8th, 2025, we hosted a hands-on graphic design workshop at Rathinam College.It was more than just learning tools—it was about unlocking creativity and exploring design careers.Students dived into Adobe Illustrator and took part in an exciting logo challenge.Their energy, curiosity, and enthusiasm were truly inspiring.We shared feedback, discussed freelancing, and explored real-world opportunities.It reminded me why I love doing this—empowering future designers.Thank you to everyone who made it a memorable day!.",
      image: "LatestBuzz/9.jpg",
    },
    {
      title: "The Hanatoria at Being Series Podcast 🎙️",
      description:
        "Being featured on the Raw & Real Podcast by Aalamaram was a special moment for Hanatoria.We shared our journey—from one client to serving 300+ businesses across industries.The episode highlighted our impact-driven creativity and brand-building approach.It brought together first-gen entrepreneurs with stories of grit and resilience.We opened up about funding, family expectations, and breaking norms.Huge thanks to Ambi Moorthy sir and Aalamaram for their constant support.We’re excited to keep building and sharing stories that truly matter.",
      image: "LatestBuzz/7.jpg",
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const groupSize = 1;

  const groupedItems = [];
  for (let i = 0; i < items.length; i += groupSize) {
    groupedItems.push(items.slice(i, i + groupSize));
  }

  const slides = [
    groupedItems[groupedItems.length - 1],
    ...groupedItems,
    groupedItems[0],
  ];

  const handleTransitionEnd = () => {
    if (currentIndex === 0) {
      setTransitionEnabled(false);
      setCurrentIndex(slides.length - 2);
    } else if (currentIndex === slides.length - 1) {
      setTransitionEnabled(false);
      setCurrentIndex(1);
    }
  };

  useEffect(() => {
    if (!transitionEnabled) {
      requestAnimationFrame(() => {
        setTransitionEnabled(true);
      });
    }
  }, [transitionEnabled]);

  const prevSlide = () => {
    if (transitionEnabled) setCurrentIndex((prev) => prev - 1);
  };

  const nextSlide = () => {
    if (transitionEnabled) setCurrentIndex((prev) => prev + 1);
  };

  return (
    <div className="relative w-full py-8">
      <div className="overflow-hidden">
        <div
          ref={sliderRef}
          className={`flex ${
            transitionEnabled
              ? "transition-transform duration-500 ease-in-out"
              : ""
          }`}
          onTransitionEnd={handleTransitionEnd}
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {slides.map((group, groupIdx) => (
            <div
              key={groupIdx}
              className="flex-shrink-0 w-full flex justify-center px-2 sm:px-4"
            >
              {group.map((item, idx) => (
                <div
                  key={idx}
                  className="w-[95%] md:w-[70%] lg:w-[85%] xl:w-[70%] mx-auto bg-[#fff8e6] rounded-xl shadow-md flex flex-col lg:flex-row overflow-hidden"
                >
                  {/* Image Section */}
                  <div className="w-full lg:w-1/2 flex justify-center items-center ">
                    <div className="w-full lg:max-w-[550px] lg:h-[400px] p-2">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-contain"
                      />
                    </div>
                  </div>

                  {/* Content Section */}
                  <div className="flex flex-col justify-center items-start px-4 md:px-6 py-4 w-full lg:w-1/2">
                    <h3 className="text-base sm:text-lg md:text-xl lg:text-2xl font-semibold text-black mb-2 font-inter leading-snug md:leading-8">
                      {item.title}
                    </h3>
                    <p className="text-sm sm:text-base md:text-base lg:text-lg leading-snug md:leading-6 text-[#1E1A1C] font-light font-lexend">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="absolute -bottom-[2rem] flex justify-center w-full px-4">
        <button
          className="text-black border-2 border-solid px-3 py-1 rounded-full hover:bg-orange-500 hover:text-white text-[1.5rem] mr-2"
          onClick={prevSlide}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
        <button
          className="text-black border-2 border-solid px-3 py-1 rounded-full hover:bg-orange-500 hover:text-white text-[1.5rem] ml-2"
          onClick={nextSlide}
        >
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </div>
    </div>
  );
};

export default Carousel;
